'use client'
import {
  Image
} from "./chunk-QINAG4RG.mjs";
import {
  Img
} from "./chunk-YF5BD7DN.mjs";
import "./chunk-X3PS6RUF.mjs";
import {
  useImage
} from "./chunk-SPIKMR6I.mjs";
export {
  Image,
  Img,
  useImage
};
//# sourceMappingURL=index.mjs.map